/* eslint-disable no-useless-escape */
import React, { useState, useContext } from "react";
import { Spinner, Button, Form, FormGroup, Label, Input } from "reactstrap";
import NotificationAlert from "react-notification-alert";
import {AuthContext} from './../../context/AuthContext';
import { setLoginData } from './../../api/request';
import { Link } from "react-router-dom";
import Logo from './../../assets/img/logo.png';

export default function Login() {
  const notificationAlertRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const {signIn} = useContext(AuthContext);

  const notifyAlert = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
      <div className="alert-text" style={{display: 'inline'}}>
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
            <br />
          </span>
          <span data-notify="message">
            {message}
          </span>
        </div>
      ),
      type: type,
      icon: "far fa-bell",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const sendData = async () => {
    setLoading(true);

    if(String(email).trim() === "") {
      notifyAlert("warning", 'Mensaje', 'El email no puede estar vacio.');
    }
    else if(/\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/.test(email) === false ) {
      notifyAlert("warning", 'Mensaje', 'El email que ha introducido no es valido');
    }
    else if(String(password).trim() === "") {
      notifyAlert("warning", 'Mensaje', 'La contraseña no puede estar vacia.');
    }
    else {
      const jsn = {
        "email": email,
        "pass": password
      }

      const res = await setLoginData(jsn);
      console.log(res.status);

      if(res.status === 404) {
        notifyAlert("danger", 'Mensaje', res.data.message);
      }
      else if(res.status === 403) {
        notifyAlert("danger", 'Mensaje', res.data.message);
      }
      else if (res.status === 200) {
        signIn(res.data);
      }
      
    }

    setLoading(false);
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <div>

        <div style={{
          textAlign: 'center'
        }}>
          <img 
            style={{
              width: '250px'
            }}
            alt="..." 
            src={Logo} />
        </div>
        
        <div 
          className="container" 
          style={{
            marginTop: '20px'
          }}>
          <Form>
            <FormGroup>
              <Label style={{fontWeight: '600'}}> E-mail </Label>
              <Input
                placeholder="Ingrese e-mail"
                type="email"
                value={email}
                onChange={(val) => setEmail(val.target.value) }
              />
            </FormGroup>

            <FormGroup>
              <Label style={{fontWeight: '600'}}> Contraseña </Label>
              <Input
                placeholder="Ingrese contraseña"
                type="password"
                value={password}
                onChange={(val) => setPassword(val.target.value) }
              />
            </FormGroup>

          </Form>

          <div 
            style={{
              textAlign: 'right', 
              marginBottom: '10px'
            }}>
            <Link to="/reset"> ¿Has olvidado tu contraseña? </Link>
          </div>

          <div style={{textAlign: 'center'}}>
            {
              (loading) ? 
                <Spinner style={{
                  color: "#040608"
                }} /> :
                <Button
                  style={{
                    backgroundColor: '#040608',
                    border: 0
                  }}
                  className="btnLogin"
                  onClick={() => sendData()}>Iniciar sesion</Button>
            }
          </div>

        </div>
      </div>
    </>
  )
}

